import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  changeMapButton: {
    marginRight: Theme.px(30),
  },
});
